import { render, staticRenderFns } from "./PaginationFooter.vue?vue&type=template&id=7e11080e&scoped=true"
import script from "./PaginationFooter.vue?vue&type=script&lang=js"
export * from "./PaginationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e11080e",
  null
  
)

export default component.exports